module.exports = __webpack_public_path__ + "img/Tchnics1210_disk.85dfa124.png";